import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const q = searchParams.get('q');
    if (q) {
      setQuery(q);
      doSearch(q);
    }
  }, [searchParams]);

  const doSearch = (q) => {
    if (!q.trim()) return;
    setLoading(true);
    api.search(q)
      .then(setResults)
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    setSearchParams({ q: query });
  };

  return (
    <div className="page">
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px', marginBottom: '28px', maxWidth: '600px' }}>
        <input
          className="input"
          style={{ marginBottom: 0, fontSize: '1rem' }}
          placeholder="Search streamers, channels..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          autoFocus
        />
        <button className="btn btn-primary" type="submit" style={{ flexShrink: 0 }}>Search</button>
      </form>

      {loading && <div style={{ color: '#adadb8', padding: '40px 0' }}>Searching...</div>}

      {results && !loading && (
        <>
          {/* Live streams */}
          {results.streams.length > 0 && (
            <div style={{ marginBottom: '32px' }}>
              <div className="section-title">🔴 Live Now</div>
              <div className="channel-grid">
                {results.streams.map(s => (
                  <div key={s.id} className="channel-card" onClick={() => navigate(`/${s.username}`)}>
                    <div className="channel-thumbnail">
                      <span className="offline-icon">📺</span>
                      <span className="live-badge">LIVE</span>
                    </div>
                    <div className="channel-info">
                      <div className="channel-name">{s.title}</div>
                      <div className="channel-category">{s.display_name || s.username}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Streamers */}
          {results.streamers.length > 0 && (
            <div>
              <div className="section-title">👤 Streamers</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '600px' }}>
                {results.streamers.map(s => (
                  <div
                    key={s.id}
                    className="panel-card"
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '14px' }}
                    onClick={() => navigate(`/${s.username}`)}
                  >
                    <div style={{
                      width: 48, height: 48, borderRadius: '50%',
                      background: '#2a2a2e', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0
                    }}>
                      {s.avatar_url ? <img src={s.avatar_url} alt="" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover' }} /> : '🎥'}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {s.display_name || s.username}
                        {s.is_live && <span className="live-badge" style={{ position: 'static' }}>LIVE</span>}
                      </div>
                      <div style={{ fontSize: '0.8rem', color: '#adadb8', marginTop: '2px' }}>
                        @{s.username} · {s.follower_count} followers · {s.category}
                      </div>
                      {s.bio && <div style={{ fontSize: '0.85rem', color: '#adadb8', marginTop: '4px' }}>{s.bio}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {results.streamers.length === 0 && results.streams.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px', color: '#adadb8' }}>
              <div style={{ fontSize: '3rem', marginBottom: '12px' }}>🔍</div>
              <h2>No results for "{searchParams.get('q')}"</h2>
              <p style={{ marginTop: '8px' }}>Try a different search term</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
